import { render, staticRenderFns } from "./BrowserToolbar.vue?vue&type=template&id=bcdfbffa"
import script from "./BrowserToolbar.vue?vue&type=script&lang=js"
export * from "./BrowserToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports